export function OutlinePaperclipIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5869 6.585L8.45691 13.715C7.66691 14.505 7.66691 15.795 8.45691 16.585C9.24691 17.375 10.5369 17.375 11.3269 16.585L17.9869 9.925C19.5669 8.345 19.5669 5.775 17.9869 4.185C16.4069 2.605 13.8369 2.605 12.2469 4.185L5.75691 10.675C3.44691 12.985 3.44691 16.725 5.75691 19.035C8.06691 21.345 11.8069 21.345 14.1169 19.035L19.9769 13.175"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
